const getMinMax = (data) => {
    function getMinX() {
        return data.reduce((min, p) => p[0] < min ? p[0] : min, data[0][0]);
    }

    function getMaxX() {
        return data.reduce((max, p) => p[0] > max ? p[0] : max, data[0][0]);
    }

    function getMinY() {
        return data.reduce((min, p) => p[1] < min ? p[1] : min, data[0][1]);
    }

    function getMaxY() {
        return data.reduce((max, p) => p[1] > max ? p[1] : max, data[0][1]);
    }

    let minmax = []; // 0 --> MinX, 1 --> MinY, 2 --> MaxX, 3 --> MaxY
    minmax.push(getMinX());
    minmax.push(getMinY());
    minmax.push(getMaxX());
    minmax.push(getMaxY());

    return minmax;
};

export default getMinMax;